module.exports = __webpack_public_path__ + "static/starmaxx-8caa48c49a4e3ca4ff7ccab5f4ace986.png";